/**
 * Format a timestamp in ms to format HH hour(s) MM min(s) SS second(s)
 * @param {float} timeStamp the timeStamp to format in ms
 *
 * @returns {string} the formatted timeStamp
 * Example of format:
 *  '22 hours 31 mins 21 seconds'
 *  '1 min 21 seconds'
 */
const formatTimeStamp = (timeStamp = 0) => {
  const timeStampInSecond = timeStamp / 1000;
  const hours = Math.floor(timeStampInSecond / 3600);
  const mins = Math.floor((timeStampInSecond - hours * 3600) / 60);
  const secs = Math.floor(timeStampInSecond - hours * 3600 - mins * 60);

  return `
    ${hours < 10 ? `0${hours}` : hours}  ${hours > 1 ? 'hours' : 'hour'}
    ${mins < 10 ? `0${mins}` : mins}  ${mins > 1 ? 'mins' : 'min'}
    ${secs < 10 ? `0${secs}` : secs}  ${secs > 1 ? 'seconds' : 'second'}
  `;
};

export default formatTimeStamp;
